// Shared language-label resolver (CG20-6180).
// Resolves a language code to a display label through a 4-step fallback chain:
//   1) i18n catalog (UI-localized, covers pt_br)   2) localization-API name (covers regional codes es_mx/en_us)
//   3) 2-letter ISO library                        4) raw code
export default {
  methods: {
    localizeLang(code) {
      if (!code) return code
      const key = code.replace(/-/g, '_').toLowerCase() // pt-br -> pt_br
      const label = this.$t('Languages.' + key)
      if (label.indexOf('.') === -1) return label
      if (this.$languagesObj && this.$languagesObj[key]) return this.$languagesObj[key]
      const iso = this.$isoCountriesLanguages.getLanguages(this.$i18n.locale)
      return (iso && iso[key]) || key
    }
  }
}
